import { createSearchParamsContext } from 'src/app/shared/contexts/SearchParamsContext'

// Create Account Setup search params context
const { Provider, useContext } = createSearchParamsContext(
  'bfa_account_setup_search_params',
  'AccountSetupFilters'
)

export const AccountSetupFiltersProvider = Provider
export const useAccountSetupFilters = useContext
